import { Modal, Button } from "react-bootstrap";

// Reusable Progress/Success Modal Component
export const ProgressModal = ({ show, onClose, title, message, variant = "success" }) => {
  const isError = variant === "danger";

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="md"
      centered
      style={{
        zIndex: 1000000,
        backdropFilter: "blur(5px)",
      }}
    >
      <Modal.Header style={{ backgroundColor: "var(--primary)", padding: 0 }}>
        <Modal.Title
          className="w-100 height-25 text-center d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: isError ? "#b42318" : "#003366",
            color: "white",
            fontSize: "14px",
          }}
        >
          {title || "Success"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          padding: "5px",
        }}
      >
        <div className="text-center m-b-5">
          <h5
            className="client-contact-title text-center"
            style={{
              backgroundColor: "#f8f9fa",
              padding: "10px",
              borderRadius: "4px",
              margin: "0 auto",
            }}
          >
            {message || "Operation completed successfully!"}
          </h5>
        </div>
      </Modal.Body>

      <Modal.Footer
        className=" p-0 mt-0 justify-content-center padding-outside-btn-new-provider"
        style={{ borderTop: "none" }}
      >
        <div className="d-flex align-items-center w-100 justify-content-center">
          <Button
            variant={variant}
            onClick={onClose}
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
          >
            OK
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
